import { default as React, memo, useCallback, useState } from "react";
import { NumberParam, useQueryParams } from "use-query-params";
import { SkillsIcon } from "../components/icons";
import ProfessionLibrary from "../components/professionSkillLibraries/ProfessionLibrary";
import SkillLibrary from "../components/professionSkillLibraries/SkillLibrary";
import {
  Container,
  ScreenContainer,
  ScreenHeader,
  Select,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "../components/wombat-ui";
import { useBreadcrumbs } from "../hooks/useBreadcrumbs";
import useTranslations from "../hooks/useTranslations";
import useViewer from "../hooks/useViewer";

import { LOCALE_OPTIONS } from "../screens/CompanyConfigurationScreen";

interface ProfessionSkillLibraryScreenProps {}

const ProfessionSkillLibraryScreen: React.FC<ProfessionSkillLibraryScreenProps> =
  () => {
    const t = useTranslations();
    const {
      locale,
    } = useViewer();

    useBreadcrumbs([
      {
        to: "/profession-skill-library",
        text: t("professionSkillLibrary.title") as string,
      },
    ]);

    const [{ tab = 0 }, setQuery] = useQueryParams({
      tab: NumberParam,
    });

    const handleTabChange = useCallback(
      (tab: number) => setQuery({ tab }),
      [setQuery]
    );

    const [selectedLocale, setSelectedLocale] = useState(locale);

    return (
      <>
        <ScreenContainer>
          <ScreenHeader
            title={
              <span className="flex items-center space-x-4">
                {t("professionSkillLibrary.title")}
              </span>
            }
            icon={SkillsIcon}
            actions={[
              <Select
                key="localeSelect"
                id="localeSelect"
                label=""
                defaultValue={selectedLocale}
                getValue={(e) => e.value}
                onChange={(e) => setSelectedLocale(e.value)}
                items={LOCALE_OPTIONS}
                renderItem={(e) => e.label}
              />,
            ]}
          />
          <Container>
            <Tabs index={tab} onChange={handleTabChange}>
              <TabList>
                <Tab>{t("professionSkillLibrary.professions")}</Tab>
                <Tab>{t("professionSkillLibrary.skills")}</Tab>
              </TabList>
              <TabPanels>
                <TabPanel className="bg-white rounded-sm">
                  <ProfessionLibrary
                    locale={selectedLocale}
                  />
                </TabPanel>
                <TabPanel className="bg-white rounded-sm">
                  <SkillLibrary
                    locale={selectedLocale}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Container>
        </ScreenContainer>
      </>
    );
  };

export default memo(ProfessionSkillLibraryScreen);
